import * as React from "react";

import "./item-receipt.scss";

import {UseState}      from "@Common/react/use-state";
import {cs}            from "@Common/react/chain-services";
import {IsShowPricing} from "@Common/logic/check-show-pricing";

import {faCaretDown,
    faCaretUp,
    faFileArchive,
    faFilePdf,
    faSearch}         from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {Summary}               from "../common/summary/summary";
import {DetailRows}            from "./detail-rows";
import {ComponentsRows}        from "./components-rows";
import {PrintTable}            from "./print-table/print-table";
import {SummarySections}       from "./summary-sections";
import {isEmptyContainer}      from "@Common/utils/objects";
import {ItemAttributesService} from "src/routes/account/orders/history-route/item-attributes";

export const ItemReceipt = ({item, cart, index, printReceipt}) => cs(
    ["showPricing", (_, next) => IsShowPricing({next})],
    ["attributesService", (_, next) => ItemAttributesService({cart, renderChildren: next})],
    ["attributes", ({attributesService}, next) => next(attributesService.mapItemAsAttributes(item))],
    ({showPricing, attributes}) => (
        <div className="item-receipt item-receipt-8un">
            <div className="header">
                <img {...{
                        src: item.proofUrls?.jpg?.[0]?.path ?? item.itemThumbnails?.[0] ?? item.thumbnail,
                        alt: item.itemName,
                        onClick: () => !printReceipt && attributes.preview && attributes.preview.run(),
                        style: {cursor: (!printReceipt && attributes.preview) ? "pointer" : "default"},
                }}/>

                <div className="middle">
                    <div className="item-name">
                        {item.itemName || item.metaData?.productName || "Brochure"}
                    </div>
                    <div className="order-id">
                        Order ID {item.itemId}
                    </div>
                    
                    {!printReceipt && <div className="links">
                        {attributes.download && (
                                <div className="link-group">
                                    <div className="label" xd-qa-type="label" xd-qa-name="Images">Images</div>
                                    {
                                        attributes.downloadImagePDF ? (
                                            downloadOptions({
                                                item,
                                                pdfOption: attributes.downloadImagePDF.run,
                                                zipOption: attributes.download.run
                                            })
                                        ) : (
                                            <a
                                                className="link"
                                                xd-qa-type="link"
                                                xd-qa-name="Download"
                                                onClick={item.deliveryStatus === "Cancelled" ? undefined : attributes.download.run}
                                            >
                                                {attributes.download.label}
                                            </a>
                                        )
                                    }
                                </div>
                            )
                        }
                        {attributes.downloadProof && (
                            <div className="link-group">
                                <div className="label" xd-qa-type="label" xd-qa-name="Proof">Proof</div>
                                {
                                    attributes.downloadZip ? (
                                        downloadOptions({
                                            item,
                                            pdfOption: attributes.downloadProof.run,
                                            zipOption: attributes.downloadZip.run
                                        })
                                    ) : (
                                        <a
                                            className="link"
                                            xd-qa-type="link"
                                            xd-qa-name={attributes.downloadProof.label}
                                            onClick={item.deliveryStatus === "Cancelled" ? undefined : attributes.downloadProof.run}
                                        >
                                            {attributes.downloadProof.label}
                                        </a>
                                    )
                                }
                            </div>
                        )}
                        {attributes.downloadPhotos && (
                            <div className="link-group">
                                <div className="label" xd-qa-type="label" xd-qa-name="Photos">Photos</div>
                                <a
                                    className="link"
                                    xd-qa-type="link"
                                    xd-qa-name="Download Photos"
                                    onClick={item.deliveryStatus === "Cancelled" ? undefined : attributes.downloadPhotos.run}
                                >
                                    {attributes.downloadPhotos.label}
                                </a>
                            </div>
                        )}
                    </div>}
                </div>

                <div className="index">
                    <div className="pill">
                        ITEM {index.index + 1} of {index.total}
                    </div>
                </div>
            </div>

            {!printReceipt && attributes.preview && (
                <div className="preview" onClick={attributes.preview.run}>
                    <FontAwesomeIcon key={item.itemId + "faSearch"} className="icon" icon={faSearch} xd-qa-type="icon" xd-qa-name="Search"/> {attributes.preview.label}
                </div>
            )}

            {!isEmptyContainer(item.components) && (
                PrintTable({
                    columns: ComponentsColumns(),
                    rows: ComponentsRows({components: item.components}),
                })
            )}

            {PrintTable({
                columns: Columns({showPricing}),
                rows: DetailRows({item, cart, showPricing}),
            })}

            {showPricing && (
                <div className="footer">
                    {Summary({
                        sections: SummarySections({item, cart,}),
                    })}
                </div>
            )}
        </div>
    ),
);

const Columns = ({showPricing}) => [
    {
        label: "ORDER DETAILS",
        className: "name",
        // width: "150px",
        align: "left",
        padding: "top",
    },
    {
        label: "QTY",
        className: "qty",
        width: "60px",
        align: "right",
        padding: "top",
    },
    {
        label: "PRICE",
        className: "price",
        width: "60px",
        align: "right",
        padding: "top",
        withPricingOnly: true,
    },
].filter(v => showPricing || !v.withPricingOnly);

const ComponentsColumns = () => [
    {
        label: "KIT'S COMPONENT(S)",
        className: "thumbnail",
        width: "150px",
        align: "left",
        padding: "top",
    },
    {
        label: "",
        className: "name",
        //width: "150px",
        align: "left",
        padding: "top",
    },
    {
        label: "QTY",
        className: "qty",
        width: "60px",
        align: "right",
        padding: "top",
    },
];

const downloadOptions = ({item, pdfOption, zipOption}) => cs(
    ["actions", ({}, next) => UseState({next})],
    ({actions}) => (
        <div className="download" onClick={() => actions.onChange(!actions.value)} xd-qa-type="link" xd-qa-name="Download">
            <a>
                Download
                {<i><FontAwesomeIcon icon={actions.value ? faCaretUp : faCaretDown}/></i>}
            </a>
            {
                actions.value &&
                <div className="actions">
                    <a
                        className="link"
                        xd-qa-type="link"
                        xd-qa-name="PDF"
                        onClick={item.deliveryStatus === "Cancelled" ? undefined : pdfOption}
                    >
                        <i><FontAwesomeIcon icon={faFilePdf}/></i> PDF
                    </a>
                    <a
                        className="link"
                        xd-qa-type="link"
                        xd-qa-name="Zip"
                        onClick={item.deliveryStatus === "Cancelled" ? undefined : zipOption}
                    >
                        <i><FontAwesomeIcon icon={faFileArchive}/></i> Zip
                    </a>
                </div>
            }
        </div>
    )
);